import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "py-10 px-4 sm:px-6 lg:px-24" }
const _hoisted_2 = { class: "mt-6 flex flex-col md:flex-row gap-4 items-center justify-between bg-gray-50/50 p-4 rounded-xl border border-gray-150 mb-6" }
const _hoisted_3 = { class: "relative w-full md:w-80" }
const _hoisted_4 = { class: "flex flex-wrap gap-4 items-center w-full md:w-auto justify-end" }
const _hoisted_5 = { class: "relative w-full sm:w-72 flex items-center gap-2" }
const _hoisted_6 = { class: "relative flex-grow" }
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 0,
  class: "flex items-center gap-2 w-full sm:w-auto"
}
const _hoisted_9 = { class: "mt-8 flow-root" }
const _hoisted_10 = { class: "-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_11 = { class: "inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8" }
const _hoisted_12 = { class: "overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg" }
const _hoisted_13 = {
  key: 0,
  class: "text-center my-8 font-medium"
}
const _hoisted_14 = {
  key: 1,
  class: "min-w-full divide-y divide-gray-300"
}
const _hoisted_15 = { class: "divide-y divide-gray-200 bg-white" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500" }
const _hoisted_18 = { class: "text-xs text-gray-400 mt-0.5" }
const _hoisted_19 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500" }
const _hoisted_20 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500" }
const _hoisted_21 = { class: "relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { key: 0 }

import { ref, onMounted, computed } from 'vue'
import { handleApiError, getUserToken, getBackendBaseUrl } from '@/utils/common'
import SlideOver from '@/widgets/SlideOver.vue'
import Agent from '@/composables/admin/agent'
import { NotificationType } from '@/types/index'
import Notification from '@/widgets/Notification.vue'
import SaveSubAgent from '@/components/agent/SaveSubAgent.vue'
import { Agent as AgentType } from '@/types/admin'
import ConfirmationModal from '@/widgets/ConfirmationModal.vue'
import axios from 'axios'


export default /*@__PURE__*/_defineComponent({
  __name: 'SubAgents',
  setup(__props) {

const isLoading = ref<boolean>(false)
const openSaveDialog = ref<boolean>(false)
const notif = ref<NotificationType>({ show: false, type: 'success', message: '', messageDetails: ''})
const { subAgents, updateSubAgent } = Agent()
const subs = ref<AgentType[]>([])
const selectedSubAgent = ref<AgentType | null>(null)
const openConfirmModal = ref<boolean>(false)
const toggleItem = ref<AgentType | null>(null)
const confirmActionType = ref<'deactivate' | 'activate'>('deactivate')
const baseUrl = getBackendBaseUrl()

// Search & Filter variables
const searchQuery = ref<string>('')
const selectedScope = ref<string>('this_month')
const startDate = ref<string>('')
const endDate = ref<string>('')

const scopes = ref([
   { id: 'all_time', name: 'Lifetime' },
   { id: 'today', name: 'Today' },
   { id: 'this_week', name: 'This Week' },
   { id: 'this_month', name: 'This Month' },
   { id: 'last_month', name: 'Last Month' },
   { id: 'this_year', name: 'This Year' },
   { id: 'last_year', name: 'Last Year' },
   { id: 'custom', name: 'Custom Date Range' }
])

onMounted(() => {
   mounted() 
})

const mounted = async () => {
   await fetchSubAgents()
}

const handleSaveSuccess = async () => {
   openSaveDialog.value = false
   notif.value = { show: true, type: 'success', message: 'Success', messageDetails: 'Your sub agent has been added successfully'}
   setTimeout(() => { notifClosed() }, 4000)
   
   await fetchSubAgents()
}

const handleSaveError = (error: string) => { 
   notif.value = { show: true, type: 'error', message: 'Error', messageDetails: error}
   setTimeout(() => { notifClosed() }, 4000)
}

const handleAdd = () => {
   selectedSubAgent.value = null
   openSaveDialog.value = true
}

const handleEdit = (agent: AgentType) => {
   selectedSubAgent.value = agent
   openSaveDialog.value = true
}

const notifClosed = () : void => {
   notif.value.show = false
}

const handleToggleStatus = (item: AgentType) => {
   toggleItem.value = item
   confirmActionType.value = item.status ? 'deactivate' : 'activate'
   openConfirmModal.value = true
}

const askingConfirmed = async () => {
   if (!isLoading.value && toggleItem.value) {
      isLoading.value = true
      const payload: any = {
         id: toggleItem.value.id,
         name: toggleItem.value.name,
         phone: toggleItem.value.phone,
         email: toggleItem.value.email,
         commission: toggleItem.value.commission,
         website_login: toggleItem.value.website_login,
         is_admin: toggleItem.value.is_admin,
         active: toggleItem.value.status ? 0 : 1,
      }
      const response = await updateSubAgent(payload)

      if (response.status == 200) {
         notif.value = { show: true, type: 'success', message: 'Success', messageDetails: `Sub agent ${confirmActionType.value}d successfully`}
         setTimeout(() => { notifClosed() }, 4000)
         await fetchSubAgents()
      } else {
         const error = handleApiError(response)
         notif.value = { show: true, type: 'error', message: 'Error', messageDetails: error}
         setTimeout(() => { notifClosed() }, 4000)
      }

      isLoading.value = false
      openConfirmModal.value = false
   }  
}

const handleConfirmClose = () => openConfirmModal.value = false

const fetchSubAgents = async () => {
   if (selectedScope.value === 'custom') {
      if (!startDate.value || !endDate.value) {
         return
      }
   }

   isLoading.value = true

   let formattedStart = ''
   let formattedEnd = ''
   if (selectedScope.value === 'custom') {
      const format = (dateStr: string) => {
         const parts = dateStr.split('-')
         return `${parts[2]}-${parts[1]}-${parts[0]}`
      }
      formattedStart = format(startDate.value)
      formattedEnd = format(endDate.value)
   }

   const response = await subAgents(selectedScope.value, formattedStart, formattedEnd)
   isLoading.value = false

   if (response.status == 200) {
      subs.value = response.data
   } else {
      const error = handleApiError(response)
      console.log(error)
   }
}

const filteredSubs = computed(() => {
   const query = searchQuery.value.toLowerCase().trim()
   if (!query) return subs.value
   return subs.value.filter(item => 
      item.name.toLowerCase().includes(query) ||
      item.email.toLowerCase().includes(query) ||
      (item.phone && item.phone.toLowerCase().includes(query))
   )
})

const downloadReport = async (agent: AgentType) => {
   let finalScope = selectedScope.value
   if (selectedScope.value === 'custom') {
      if (!startDate.value || !endDate.value) {
         notif.value = { show: true, type: 'error', message: 'Date Missing', messageDetails: 'Please select both start and end dates first.'}
         setTimeout(() => { notifClosed() }, 4000)
         return
      }
      
      const format = (dateStr: string) => {
         const parts = dateStr.split('-')
         return `${parts[2]}-${parts[1]}-${parts[0]}`
      }
      finalScope = `custom_${format(startDate.value)}_${format(endDate.value)}`
   }

   try {
      isLoading.value = true
      const url = `${baseUrl}api/agent/reports/sub-agent/bookings/${agent.id}/${finalScope}/download`
      const response = await axios.get(url, {
         headers: {
            'Authorization': `Bearer ${getUserToken()}`
         },
         responseType: 'blob'
      })

      let filename = `Booking_Report_${agent.name.replace(/\s+/g, '_')}_${finalScope}.csv`
      const disposition = response.headers['content-disposition']
      if (disposition && disposition.indexOf('attachment') !== -1) {
         const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
         const matches = filenameRegex.exec(disposition)
         if (matches != null && matches[1]) { 
            filename = matches[1].replace(/['"]/g, '')
         }
      }

      const blob = new Blob([response.data], { type: 'text/csv' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      
      notif.value = { show: true, type: 'success', message: 'Success', messageDetails: 'Booking report downloaded successfully'}
      setTimeout(() => { notifClosed() }, 4000)
   } catch (error) {
      notif.value = { show: true, type: 'error', message: 'Download Failed', messageDetails: 'Failed to download booking report. Please try again.'}
      setTimeout(() => { notifClosed() }, 5000)
      console.error(error)
   } finally {
      isLoading.value = false
   }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", { class: "sm:flex sm:items-center" }, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "sm:flex-auto" }, [
          _createElementVNode("h1", { class: "text-base font-semibold leading-6 text-gray-900" }, "Sub-Agents"),
          _createElementVNode("p", { class: "mt-2 text-sm text-gray-700" }, "A list of all sub agents under your account")
        ], -1)),
        _createElementVNode("div", { class: "mt-4 sm:ml-16 sm:mt-0 sm:flex-none" }, [
          _createElementVNode("button", {
            onClick: handleAdd,
            type: "button",
            class: "block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          }, " Add Sub Agent ")
        ])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400" }, [
            _createElementVNode("i", { class: "pi pi-search text-xs" })
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
            type: "text",
            placeholder: "Search by name, email or phone...",
            class: "w-full pl-9 pr-4 py-2 border border-gray-300 rounded-lg text-sm bg-white outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all duration-300"
          }, null, 512), [
            [_vModelText, searchQuery.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-xs font-semibold text-gray-500 whitespace-nowrap" }, "Filter Bookings:", -1)),
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedScope).value = $event)),
                onChange: fetchSubAgents,
                class: "w-full pl-3 pr-8 py-2 border border-gray-300 rounded-lg text-sm bg-white outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent appearance-none transition-all duration-300 cursor-pointer"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scopes.value, (scope) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: scope.id,
                    value: scope.id
                  }, _toDisplayString(scope.name), 9, _hoisted_7))
                }), 128))
              ], 544), [
                [_vModelSelect, selectedScope.value]
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none text-gray-400" }, [
                _createElementVNode("i", { class: "pi pi-chevron-down text-xs" })
              ], -1))
            ])
          ]),
          (selectedScope.value === 'custom')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((startDate).value = $event)),
                  onChange: fetchSubAgents,
                  class: "border border-gray-300 rounded-lg px-3 py-1.5 text-sm outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                }, null, 544), [
                  [_vModelText, startDate.value]
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-gray-400 text-sm" }, "to", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((endDate).value = $event)),
                  onChange: fetchSubAgents,
                  class: "border border-gray-300 rounded-lg px-3 py-1.5 text-sm outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                }, null, 544), [
                  [_vModelText, endDate.value]
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              (isLoading.value && subs.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, "...loading data. please wait"))
                : (_openBlock(), _createElementBlock("table", _hoisted_14, [
                    _cache[15] || (_cache[15] = _createElementVNode("thead", { class: "bg-gray-50" }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", {
                          scope: "col",
                          class: "py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                        }, "Name"),
                        _createElementVNode("th", {
                          scope: "col",
                          class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        }, "Email / Phone"),
                        _createElementVNode("th", {
                          scope: "col",
                          class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        }, "Loyalty Points"),
                        _createElementVNode("th", {
                          scope: "col",
                          class: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                        }, "Bookings"),
                        _createElementVNode("th", {
                          scope: "col",
                          class: "px-3 py-3.5 text-right text-sm font-semibold text-gray-900 pr-6"
                        }, " Actions ")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredSubs.value, (item) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.id
                        }, [
                          _createElementVNode("td", {
                            onClick: ($event: any) => (_ctx.$router.push({name: 'AccountDashboard', params: {'agent': item.id}})),
                            class: "whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 capitalize cursor-pointer text-indigo-600 hover:text-indigo-900"
                          }, _toDisplayString(item.name), 9, _hoisted_16),
                          _createElementVNode("td", _hoisted_17, [
                            _createElementVNode("div", null, _toDisplayString(item.email), 1),
                            _createElementVNode("div", _hoisted_18, _toDisplayString(item.phone), 1)
                          ]),
                          _createElementVNode("td", _hoisted_19, _toDisplayString(item.loyalty_points), 1),
                          _createElementVNode("td", _hoisted_20, _toDisplayString(item.booking_count), 1),
                          _createElementVNode("td", _hoisted_21, [
                            _createElementVNode("span", {
                              onClick: ($event: any) => (downloadReport(item)),
                              class: "text-indigo-600 hover:text-indigo-900 cursor-pointer font-semibold"
                            }, "Booking Report", 8, _hoisted_22),
                            _cache[11] || (_cache[11] = _createTextVNode(" | ")),
                            _createElementVNode("span", {
                              onClick: ($event: any) => (_ctx.$router.push({name: 'UserBookings', params: {'userType' : 'agent', 'subUserId' : item.id}})),
                              class: "text-indigo-600 hover:text-indigo-900 cursor-pointer"
                            }, "Bookings", 8, _hoisted_23),
                            _cache[12] || (_cache[12] = _createTextVNode(" | ")),
                            _createElementVNode("span", {
                              onClick: ($event: any) => (handleEdit(item)),
                              class: "text-indigo-600 hover:text-indigo-900 cursor-pointer"
                            }, "Edit", 8, _hoisted_24),
                            _cache[13] || (_cache[13] = _createTextVNode(" | ")),
                            _createElementVNode("span", {
                              onClick: ($event: any) => (handleToggleStatus(item)),
                              class: "text-indigo-600 hover:text-indigo-900 cursor-pointer"
                            }, _toDisplayString(item.status ? 'Deactivate' : 'Activate'), 9, _hoisted_25)
                          ])
                        ]))
                      }), 128)),
                      (filteredSubs.value && filteredSubs.value.length == 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_26, _cache[14] || (_cache[14] = [
                            _createElementVNode("td", {
                              colspan: "5",
                              class: "text-center whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6"
                            }, " No sub agents created yet ", -1)
                          ])))
                        : _createCommentVNode("", true)
                    ])
                  ]))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(ConfirmationModal, {
      show: openConfirmModal.value,
      onClosed: handleConfirmClose
    }, {
      buttons: _withCtx(() => [
        _createElementVNode("button", {
          onClick: askingConfirmed,
          type: "button",
          class: _normalizeClass([[isLoading.value ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer', confirmActionType.value === 'deactivate' ? 'bg-red-600 hover:bg-red-500' : 'bg-green-600 hover:bg-green-500'], "inline-flex w-full justify-center rounded-md px-3 py-2 text-sm text-white shadow-sm xs:ml-3 xs:w-auto capitalize"])
        }, _toDisplayString(confirmActionType.value), 3),
        _createElementVNode("button", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (openConfirmModal.value = false)),
          type: "button",
          class: "mt-3 inline-flex w-full cursor-pointer justify-center rounded-md bg-white px-3 py-2 text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 xs:mt-0 xs:w-auto"
        }, "Cancel")
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(SlideOver, {
      show: openSaveDialog.value,
      onClosed: _cache[5] || (_cache[5] = ($event: any) => (openSaveDialog.value = false))
    }, {
      content: _withCtx(() => [
        _createVNode(SaveSubAgent, {
          data: selectedSubAgent.value,
          onSuccess: handleSaveSuccess,
          onError: handleSaveError
        }, null, 8, ["data"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(Notification, {
      show: notif.value.show,
      type: notif.value.type,
      message: notif.value.message,
      messageDetails: notif.value.messageDetails,
      onClosed: notifClosed
    }, null, 8, ["show", "type", "message", "messageDetails"])
  ], 64))
}
}

})